const { h, Component } = require('preact');

class FeedbackSuceess extends Component {

  handleDoneButton(){
    if(this.props.openInNewTab) {
      window.open(this.props.navigatingToUrl);
      this.props.hideFeedbackModal();
    } else {
      window.location.href = this.props.navigatingToUrl;
    }
  }

  render() {
    return (
      <div class="feedback-success">
        <div class="icon-check-circle" />
        <div data-bhw="CUSTOMER-FEEDBACK::thank_you_message" class="feedback-thank-you">{I18n.translate('js.modules.web_2018.feedback.thank_you')}</div>
        <div class="feedback-success-bottom">
            <div class="done-button">
              <div class="btn" data-bhw="CUSTOMER-FEEDBACK::thank_you_done" onClick={this.handleDoneButton.bind(this)}>{I18n.translate('js.modules.web_2018.feedback.done')}</div>
            </div>
          </div>
      </div>
    )
  }
}

module.exports = FeedbackSuceess;